// @flow
import React from 'react';
import { isEmpty } from 'lodash';

import DynamicLink, {
  type Props as DynamicLinkProps,
} from 'Components/frameworks/dynamic-link/DynamicLink.jsx';
import { Tag, type TagProps } from 'Components/frameworks/tag/Tag.jsx';
import { Text, type TextProps } from 'Components/frameworks/text/Text.jsx';

import { CardHeading, type CardHeadingProps } from './card-heading/CardHeading.jsx';

import { cardHeaderThemes } from './CardHeader.themes';

type Props = {
  color?: Colors,
  heading?: CardHeadingProps,
  introduction?: TextProps,
  link?: ?DynamicLinkProps,
  tags?: Array<TagProps>,
  theme?: string,
};

export function CardHeader(props: Props) {
  const { color, heading, introduction, link = {}, tags = [], theme = 'default' } = props;

  const { thHeading, thIntro, thTag, thTags } = cardHeaderThemes[theme];

  // eslint-disable-next-line clubmed/no-fake-component
  const withLink = node => {
    return link && link.url ? (
      <DynamicLink {...link} className="block">
        {node}
      </DynamicLink>
    ) : (
      node
    );
  };

  return (
    <header>
      {withLink(<CardHeading {...heading} className={thHeading} color={color} theme={theme} />)}
      {!!introduction && <Text className={thIntro} {...introduction} />}
      {!isEmpty(tags) && (
        <ul className={thTags}>
          {tags.map((tag, idx) => (
            <li className={thTag} key={tag.label || idx}>
              <Tag {...tag} />
            </li>
          ))}
        </ul>
      )}
    </header>
  );
}
